import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator';
import UserMini from '@/components/user/mini/user-mini.vue';
import dataOptions, { DataOptions } from '@/shared/model/DataOptions';
// import { User } from '@/shared/model/user';
import { Logger } from 'fsts';
import { namespace } from 'vuex-class';
import DateUtils from '@/shared/utils/DateUtils';
import TreeNavigator from '@/components/tree-navigator/tree-navigator.vue';
import mitgliederPLZGebietList, { TblMitglieder } from '@/shared/model/tblMitglieder';
import searchFormKollegenauslieferung from '@/views/kollegenauslieferung/search-form-kollegenauslieferung/search-form-kollegenauslieferung.vue';
import searchFormLieferanten from '@/views/lieferanten/search-form-lieferanten/search-form-lieferanten.vue';
import searchFormMitglieder from '@/views/mitglieder/search-form-mitglieder/search-form-mitglieder.vue';
import admpNewsSearchForm from '@/views/home/news-list/admp-news-search-form/search-form-admp-news.vue';
import searchFormEntraJobs from '@/views/entrajobs/search-form-entrajobs/search-form-entrajobs.vue';
import { TranslateResult } from 'vue-i18n';
// import GeneralUtils from '@/shared/utils/generalUtils';
const logger = new Logger('components.position-list');
const dateUtils = DateUtils;
const tblMitgliederModule = namespace('tblMitglieder');
const tblLieferantenModule = namespace('tblLieferanten');

@Component({
  name: 'd4y-table',
  components: {
    TreeNavigator,
    searchFormKollegenauslieferung,
    searchFormLieferanten,
    searchFormMitglieder,
    admpNewsSearchForm,
    searchFormEntraJobs,
  },
})
export default class D4yTable extends Vue {
  @tblMitgliederModule.Getter('getMitgliedersSearchParams')
  private mitgliedersSearchParams!: any;
  @tblMitgliederModule.Getter('getMitgliederSearchData')
  private getMitgliederSearchData!: any;

  @tblMitgliederModule.Action('getMitglieder')
  private actionGetMitgliederData!: any;

  @tblMitgliederModule.Action('getMitgliederGebietPLZ')
  private actionGetMitgliederGebietPLZData!: any;
  @tblLieferantenModule.Getter('getLieferantensIsLoading')
  private lieferantensIsLoading!: boolean;

  @tblLieferantenModule.Getter('getIsLoadingExcelReport')
  private isLoadingExcelReport!: any;

  @Prop()
  private items!: any[];

  @Prop()
  private SwitchView!: string;
  @Prop()
  private infoText!: string;
  @Prop({ default: false })
  private isInfoText!: boolean;
  @Prop({ default: false })
  private isBigInfoText!: boolean;

  @Prop({ default: false })
  private isNameAsRef!: boolean;
  @Prop({ default: false })
  private isTitleAsRef!: boolean;
  @Prop({ default: false })
  private isFirstNameAsRef!: boolean;
  @Prop({ default: false })
  private isTextAsRef!: boolean;
  @Prop({
    default: () => {
      return { menuItems: [], facetSearch: false, menuDisabled: false, hasResults: true, chipData: [] };
    },
  })
  searchMenuObj!: any;

  @Prop({ default: true })
  private isVisibleSearch!: boolean;

  @PropSync('options', {
    default: (): DataOptions => {
      return dataOptions.getDefault;
    },
  })
  private optionsDto!: DataOptions;

  @Prop({ default: () => [''] })
  private filterFields!: string[];

  // TODO:(EGRUP-79) same @Prop here and in the `tree-navigator` component probably better use Vuex state
  @Prop()
  private image?: {
    src: string;
    header: string;
    height: number;
    width: number;
  };

  @Prop()
  private selection?: {
    showSelect: boolean;
    singleSelect: boolean;
    customHeader: boolean;
  };

  // TODO:(EGRUP-105) same @Prop here and in the `tree-navigator` component probably better use Vuex state or another approach
  @Prop({ default: true })
  private expanded!: boolean;
  @Prop({ default: false })
  private tableHasFilterBtn!: boolean;
  @Prop({ default: false })
  private hasFooterBtn!: boolean;
  @Prop({ default: false })
  private isFooterBtnDisabled!: boolean;
  @Prop({ default: true })
  private isShowSearchField!: boolean;
  @Prop({ default: false })
  private preventMultiSort!: boolean;
  @Prop({ default: false })
  private isDownload!: boolean;
  @Prop({ default: false })
  private isCompleted!: boolean;

  @Prop({ default: () => '' })
  private tableHeaderText!: string;
  @Prop({ default: () => 'search' })
  private searchLabel!: string;

  @Prop()
  private breadcrumbs!: any;
  @Prop({ default: false })
  private allowAdd!: boolean;
  @Prop({ default: false })
  private showDialog!: boolean;
  @Prop({ default: true })
  private isShowTableHeader!: boolean;
  @Prop({ default: true })
  private isShowTreeNavToolbar!: boolean;

  @Prop({ default: false })
  private loadingFacet!: boolean;

  @Prop({ default: false })
  private loading!: boolean;

  @Prop()
  private serverItemsLength!: number;

  @Prop({ default: false })
  allowDelete!: boolean;

  @Prop({ default: false })
  allowEdit!: boolean;

  @Prop({ default: false })
  haveMoreActions!: boolean;
  @Prop({ default: true })
  hasBodySlot!: boolean;

  @Prop({ default: false })
  private isSearchDataEmpty!: boolean;

  @Prop({ default: false })
  private loadingFiles!: boolean;
  @Prop()
  private selectedProp!: any;
  @Prop({ default: false })
  private resetSearchOnCreate!: boolean;

  private viewType: number = 0;

  // @Watch('optionsDto.filter')
  // public onOptionsFilterChanged(newVal: any, oldVal: any) {
  //   logger.debug(`----filter:${oldVal}->${newVal}`);
  //   this.$emit('update:options', this.optionsDto);
  // }

  plzGebietMitgliederList: TblMitglieder = mitgliederPLZGebietList.parse({});
  private searchTerm = '';
  private changeSearch(value: string) {
    if (value !== this.optionsDto.filter) {
      if (this.isMitgliederRoutes) {
        this.hideSubTanle();
      }
      this.optionsDto.filter = value;
      if (this.optionsDto.page === 1) {
        this.$emit('update:options', this.optionsDto);
      } else {
        // Changing page fires onOptionsPageChanged watcher, which emits update:options
        this.optionsDto.page = 1;
      }
    }
  }

  private changeFacetSearch(value: string) {
    // (GSP-074) if `menuDisabled` is true this means that facetSearch was completed and new request is sent (possibly for other field), otherwise (`menuDisabled` == false) user trying to send another request with the same unprocessed result from previous request (not choosing anything)
    if (value.length >= 2 && (value !== this.optionsDto.filter || this.searchMenuObj.menuDisabled)) {
      if (this.isMitgliederRoutes) {
        this.hideSubTanle();
      }
      this.optionsDto.filter = value;
      this.optionsDto.page = 1; // (GSP-082) go to 1st page, when change search word
      this.$emit('update:options', this.optionsDto, 'search');
    }
  }

  private resetSearch() {
    if (this.isMitgliederRoutes) {
      this.hideSubTanle();
    }
    this.optionsDto.filter = '';
    if (this.optionsDto.page === 1) {
      this.$emit('update:options', this.optionsDto);
    } else {
      // Changing page fires onOptionsPageChanged watcher, which emits update:options
      this.optionsDto.page = 1;
    }
  }

  private sortDesc?: string;
  clickSortAsc() {
    var sort: boolean[] = [];
    this.optionsDto.sortBy.forEach((fieldName, i) => {
      sort.push(false);
    });
    this.optionsDto.sortDesc = sort;
  }
  clickSortDesc() {
    var sort: boolean[] = [];
    this.optionsDto.sortBy.forEach((fieldName, i) => {
      sort.push(true);
    });
    this.optionsDto.sortDesc = sort;
  }
  clickSortEmpty() {
    this.optionsDto.sortDesc = [];
    this.optionsDto.sortBy = [];
  }

  // make 2 request to backend if in global watch by object
  // when update sortDesc sortBy to changed
  @Watch('optionsDto.sortBy', { deep: true })
  public onOptionsSortByChanged(newVal: string[], oldVal: string[]) {
    logger.debug(`----sortBy:${oldVal}->${newVal}`);
    if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
      // Unfortunately there is no prop in v-data-table that does this, so needs to be done manually here.
      if (newVal.length > 1 && this.preventMultiSort) {
        this.optionsDto.sortBy = [this.optionsDto.sortBy.pop()];
        this.optionsDto.sortDesc = [(this.optionsDto.sortDesc as boolean[])?.pop() ?? this.optionsDto.sortDesc];
      }

      this.$emit('update:options', this.optionsDto);
    }
  }
  @Watch('optionsDto.sortDesc')
  public onOptionssortDescChanged(newVal: any, oldVal: any) {
    const oldValAsString = JSON.stringify(oldVal);
    const newValAsString = JSON.stringify(newVal);
    logger.debug(`-od-sortDesc:${oldValAsString}->${newValAsString}`);
    if (oldValAsString != newValAsString) {
      this.sortDesc = newValAsString;
      logger.debug('+');
      this.$emit('update:options', this.optionsDto);
    }
  }
  @Watch('optionsDto.page')
  public onOptionsPageChanged(newVal: any, oldVal: any) {
    logger.debug(`----page:${oldVal}->${newVal}`);
    this.$emit('update:options', this.optionsDto);
  }

  get isSortByEmpty() {
    return this.optionsDto.sortBy.length < 1;
  }

  // (AD-210) need these Prop+Watcher to remove checkbox (selection) in table when file was downloaded (up to 25 records can be selected)
  @Watch('selectedProp', { deep: true })
  public changeSelected(newVal: any, oldVal: any) {
    //(AD-210) for some reason `newVal` ALWAYS equal to `oldVal` (even if use additional variables with `Object.assign`)
    this.selected = newVal;
  }

  selected: any = [];
  selectItem(item: any) {
    if (!item.value) delete item.item; // remove item if value not selected
    this.$emit('selected:item', item.item);
  }

  enterSelect(value: any) {
    this.$emit('enterselect:item', value);
  }

  downloadFiles() {
    this.$emit('downloadFiles:item');
  }

  completedFiles() {
    this.$emit('completedFiles:item');
  }

  /**
   * Check if named slot used in the `d4y-table` implementation in parent components (like `groups`[groups_list in Sketch], etc)
   * @param name (name of the slot)
   */
  private hasSlot(name: string) {
    return !!this.$slots[name] || !!this.$scopedSlots[name];
  }

  @Prop({ default: () => [{ text: 'email', value: 'email' }] })
  private headers!: {
    text: string | any;
    value: string;
    sortable?: boolean;
    width?: string;
  }[];

  @Prop({ default: 'primary' })
  private color!: string;
  get searchListLabel() {
    // if (this.filterFields && this.filterFields.length > 0) label = `${this.$t('search', { 0: this.filterFields })}`;
    // logger.debug(`search label:${this.filterFields} -> ${label}`);
    return this.searchLabel;
  }

  formatDate(date: any) {
    var sdate = dateUtils.toDateString(date);
    logger.debug(sdate);
    return sdate;
  }
  created() {
    this.sortDesc = JSON.stringify(this.optionsDto.sortDesc);
    this.searchTerm = this.resetSearchOnCreate ? '' : this.optionsDto.filter ?? ''; // populate `search` text input if filter is set in optionsDto  and `resetSearchOnCreate` is false
  }

  get isKollegenauslieferungRoutes() {
    return this.$route.fullPath.includes('kollegenauslieferung');
  }

  get isLieferantenRoutes() {
    return this.$route.fullPath.includes('lieferanten');
  }

  get isMitgliederRoutes() {
    return this.$route.fullPath.includes('mitglieder');
  }

  get isNewsRoute() {
    return this.$route.fullPath.includes('news');
  }

  get isEntraJobsRoutes(): boolean {
    return this.$route.fullPath.includes('entra');
  }

  get isFlexWrapWidth() {
    return this.$vuetify.breakpoint.width < 730;
  }

  private changeSearchInput(value: string) {
    if (value && value.length == 0 && this.optionsDto.filter && this.optionsDto.filter?.length > 0) {
      this.optionsDto.filter = value;
      this.$emit('update:options', this.optionsDto, 'search');
    } else if (value?.length == 0) {
      this.resetSearch();
    }
  }

  searchInRealObjects(item: any) {
    this.$emit('search:chip', item);
    if (item.field !== 'all') {
      this.searchTerm = '';
    }
  }

  removeChip(item: any) {
    if (this.isMitgliederRoutes) {
      this.hideSubTanle();
    }
    this.$emit('remove:chip', item);
  }

  hasDoneDateCompleted(item: any) {
    console.log('item :>> ', item);
    console.log('!!item.documentDoneTimeCompleted :>> ', !!item.documentDoneTimeCompleted);
    return (
      !!item.documentDoneTimeCompleted ||
      !!item.supplierDoneTimeCompleted ||
      !!item.conditionDoneTimeCompleted ||
      !!item.newsDoneTimeCompleted
    );
  }

  // check data when select all in header
  private selectAll(e: any) {
    console.log('selectAll :>> ', e);
    if (e.items) {
      // e.items = e.items.filter((x:any)=> !x.documentDoneTimeCompleted)
    }
    console.log(' e.items :>> ', e.items);
  }

  private clearAllFilters() {
    if (this.isMitgliederRoutes) {
      this.hideSubTanle();
    }
    this.searchTerm = '';
    this.$emit('click:clear-all-filter');
  }

  get tooltipText() {
    if (this.isKollegenauslieferungRoutes) {
      return this.$t('kollegenauslieferung_tooltip_fields');
    }
    if (this.isLieferantenRoutes) {
      return this.$t('lieferantenRoutes_tooltip_fields');
    }
    if (this.isEntraJobsRoutes) {
      return this.$t('entraJobsRoutes_tooltip_fields');
    }
    return '';
  }

  private rowExpanded(mitglieder: any) {
    this.plzGebietMitgliederList = mitgliederPLZGebietList.parse({});
    let expandedLists = document.querySelectorAll<HTMLElement>('.mdi-chevron-down.mdi-flip-v');
    expandedLists.forEach((element) => {
      element.click();
    });
    if (mitglieder.value) {
      this.getMitgliederSearchData.gebietPLZ = mitglieder.item.plzGebietFull;
      this.actionGetMitgliederGebietPLZData({
        zrNumbersId: mitglieder.item.zrNumbersId,
        statusCompanies: mitglieder.item.statusCompanies,
        gebietPLZ: mitglieder.item.plzGebietFull,
        searchFacetFields: this.mitgliedersSearchParams.andClauseFieldsIds,
      })
        .then((result: any) => {
          this.plzGebietMitgliederList = result[0];
        })
        .catch((err: any) => {
          logger.error(err);
        });
    }
  }

  private getViewTable(typeView: number) {
    if (this.isMitgliederRoutes) {
      this.hideSubTanle();
    }
    this.$emit('click:loadViewTable', typeView);
  }

  private hideSubTanle() {
    let expandedLists = document.querySelectorAll<HTMLElement>('.mdi-chevron-down.mdi-flip-v');
    expandedLists.forEach((element) => {
      element.click();
    });
  }

  private expandTable = {
    src: 'expand_table.svg',
    header: '',
    height: 28,
    width: 28,
  };

  private table = {
    src: 'table.svg',
    header: '',
    height: 28,
    width: 28,
  };

  outputLieferantenData() {
    this.$emit('click:outputLieferantenData');
  }

  outputExcelReport() {
    this.$emit('click:outputExcelReport');
  }

  get tableFooterProps() {
    if (this.isNewsRoute) {
      return { itemsPerPageOptions: [12, 15, 20, 25] };
    }

    if (this.isLieferantenRoutes) {
      return { itemsPerPageOptions: [5, 10, 15, 20, 25, -1] };
    }

    // Updated options: 10, 25, 50, 100, (maeybe use -1 (All))
    return {
      itemsPerPageOptions: [5, 10, 25, 50, 100],
    };
  }

  get customItemsPerPageOptions(): number[] {
    if (this.isNewsRoute) {
      return [12, 15, 20, 25];
    }

    if (this.isLieferantenRoutes) {
      return [5, 10, 15, 20, 25, -1];
    }

    return [5, 10, 25, 50, 100];
  }
}
